"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Shadow = void 0;
var Shadow;
(function (Shadow) {
    Shadow["Normal"] = "u-shadow";
    Shadow["Reset"] = "u-shadow-reset";
    Shadow["Light"] = "u-shadow-light";
    Shadow["Heavy"] = "u-shadow-heavy";
    Shadow["Ambient"] = "u-shadow-ambient";
    Shadow["Inset"] = "u-shadow-inset";
})(Shadow = exports.Shadow || (exports.Shadow = {}));
//# sourceMappingURL=Shadow.js.map